import { withJsonFormsControlProps } from '@jsonforms/react'
import { componentTester, ComponentSystem } from '../component/Component'

export const componentSystem = {
  tester: componentTester,
  renderer: withJsonFormsControlProps(ComponentSystem),
}

export const componentSystemRenderer = {
  component: {
    tester: componentTester,
    renderer: withJsonFormsControlProps(ComponentSystem),
  },
}
